import type { Language } from '../types/language';
import { en, type DomainCopy } from './en';
import { es, esSources } from './es';
import { overlay } from './keys';

// named for the package, so they never collide with an app's own `en` / `es` tables
export { en as domainEn, es as domainEs, esSources as domainEsSources };
export type { DomainCopy };

/** The Spanish table with English under any key it lacks — so a missing line reads in English, never as nothing. */
const esFull: DomainCopy = overlay(en, es);

/**
 * **The domain package's words in a language** (English when none is given). Every helper in `@kk/domain` that builds a
 * user-facing line reads it from here, so passing a language to the helper is all a caller does.
 */
export function domainCopy(language?: Language): DomainCopy {
  return language === 'es' ? esFull : en;
}
